module.exports = __webpack_public_path__ + "static/media/c7078943fc392e7dede27a20e6cfdcfb.c7078943.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/c7078943fc392e7dede27a20e6cfdcfb.svg
// module id = 1084
// module chunks = 21